import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBase } from './button-base';
export const Button = (props) => {
    return _jsx(ButtonBase, { ...props });
};
Button.displayName = 'Button';
